package dev.lingvo.site.pages.app.settings

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.styleModifier
import dev.lingvo.shared.BillingOverviewDto
import dev.lingvo.shared.Role
import dev.lingvo.shared.atLeast
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.LLinkButton
import dev.lingvo.site.ds.LMuted
import dev.lingvo.site.ds.Space
import dev.lingvo.site.i18n.t

internal enum class CreditAttention { EXHAUSTED, LOW, NONE }

internal fun creditAttention(billing: BillingOverviewDto, daysRemaining: Int): CreditAttention {
    if (billing.creditsRemaining <= 0) return CreditAttention.EXHAUSTED
    val allowance = billing.creditsIncluded.toLong() + billing.creditsGranted
    return if (allowance > 0 && billing.creditsUsed.toLong() * 100 > allowance * 90 && daysRemaining > 7) {
        CreditAttention.LOW
    } else CreditAttention.NONE
}

@Composable
internal fun CreditRecovery(role: Role?) {
    Column(Modifier.gap(Space.SM)) {
        LMuted(t("app.settings.credit_recovery.manual_translation_import_export_review_and", "Manual translation, import, export, review and QA remain available. " +
            "You can also wait for the monthly credit reset. Your own provider key uses no Lingvo credits; provider charges still apply."))
        if (role == null || !role.atLeast(Role.ADMIN)) {
            LMuted(t("app.settings.credit_recovery.ask_an_owner_or_admin_to", "Ask an owner or admin to configure a provider key, or an owner to review plans."))
        } else {
            Row(Modifier.gap(Space.SM).styleModifier { property("flex-wrap", "wrap") }) {
                LLinkButton(
                    label = t("app.settings.credit_recovery.use_your_own_provider_key", "Use your own provider key"),
                    path = "/app/settings/providers",
                    variant = LButtonVariant.SECONDARY,
                )
                if (role == Role.OWNER) {
                    LLinkButton(
                        label = t("app.settings.credit_recovery.review_plans", "Review plans"),
                        path = "/app/settings/billing/plans",
                        variant = LButtonVariant.GHOST,
                    )
                }
            }
            if (role != Role.OWNER) LMuted(t("app.settings.credit_recovery.only_a_workspace_owner_can_change", "Only a workspace owner can change the plan."))
        }
    }
}
